import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slice/authSlice';
import findJobSlice from './slice/findJobSlice';
import hamburgerSlice from './slice/hamburgerSlice';
import homeSlice from './slice/homeSlice';
import commonSlice from './slice/commonSlice';

export default configureStore({
    reducer: {
        auth: authSlice,
        findJob: findJobSlice,
        hamburger: hamburgerSlice,
        home: homeSlice,
        common:commonSlice
    }
});